import { Input } from 'antd';
import React from 'react';
import '../tiledTitleList.less';

export default class TitleSearch extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			visible: false,
		};
	}

	render() {
		return (
			<div className="search-bar">
				<span className="column title-search-text">Search</span>
				<div className="column-spaced">
					<Input
						onChange={this.onSearchInputChange}
						value={this.state.value}
						size="small"
					/>
				</div>
				<div className="clear" />
			</div>
		);
	}

	onSearchInputChange = e => {
		const { value } = e.target;
		this.setState({ value });

		const { titles } = this.props;
		var searchResults = titles.filter(
			li =>
				(li.name &&
					li.name.toLowerCase().indexOf(value.toLowerCase()) > -1) ||
				(li.author &&
					li.author.toLowerCase().indexOf(value.toLowerCase()) > -1),
		);

		this.props.sendSearchData(
			titles ? searchResults.map(item => item.sku) : [],
			value.length,
		);
	};
}
